export default __webpack_public_path__ + "static/media/red_tuna.6040a69e.png";